<template>
  <div class="checkboxContainer" :class="`color-${color} size-${size}`" @click="$emit('click', !checked)">
    <input :data-flag="dataFlag" type="checkbox" :checked="checked" />
  </div>
</template>

<script>
export default {
  props: {
    checked: Boolean,
    color: {
      type: String,
      default: 'black'
    },
    size: {
      type: String,
      default: 'lg'
    },
    dataFlag: String
  },
}
</script>

<style scoped lang="scss">
.checkboxContainer {
  display: flex;
  &.color-black {
    border-color: black;
    > input[type="checkbox"] {
      border-color: black;
      background: black;
    }
  }
  &.color-green {
    border-color: #00cf6b;
    > input[type="checkbox"] {
      border-color: #00cf6b;
      background: #00cf6b;
    }
  }
  &.size-lg {
    width: 30px;
    height: 30px;
    padding: 4px;
    > input[type="checkbox"] {
      width: 18px;
      height: 18px;
    }
  }
  &.size-md {
    width: 20px;
    height: 20px;
    padding: 2px;
    > input[type="checkbox"] {
      width: 12px;
      height: 12px;
    }
  }
  border: solid;
  border-radius: 50%;
  border-width: 2px;
  cursor: pointer;
}

input[type="checkbox"] {
  border: solid;
  border-radius: 50%;
  border-width: 1px;
  background: black;
  width: 18px;
  height: 18px;
  appearance: none;
  transform: scale(0);
  cursor: pointer;
}

input[type="checkbox"]:checked {
  transform: scale(1);
}
</style>